export interface TicketFilters {
  statuses: string[];
  priorities: string[];
  types: string[];
  assignees: string[];
  tags: string[];
}

export interface TicketSort {
  sortBy: string;
  sortDirection: "asc" | "desc";
}

export const DEFAULT_SORT: TicketSort = {
  sortBy: "created",
  sortDirection: "desc",
};

export const EMPTY_FILTERS: TicketFilters = {
  statuses: [],
  priorities: [],
  types: [],
  assignees: [],
  tags: [],
};
